//cars-ng-ad, cars-ng-tracking, cars-ng browser are all aliased in webpack config

import angular from 'angular';
import CuiLazyLoader from './lazyLoader';
import NgAd from 'cars-ng-ad';
import NgCookies from 'angular-cookies';
import NgTracking from 'cars-ng-tracking';
import Overlays from 'cars-ng-overlays';
import Graphics from './cuiIcon/lib';
import Tabs from "cars-ng-tabs";

let CarsUiAngular = angular.module('cars.ui.angular', [
    Overlays,
    Graphics,
    Tabs
])
.config([() => {}])
.name;

import cobrandBar from 'cars-ng-navigation/lib/header/cobrandBar.component';

import 'cars-ng-navigation/lib/header/header.scss';

angular.module('cui.navigation.header', [])
    .component('cuiCobrandBar', cobrandBar)
    .name;


import 'cars-ui/dist/css/index.css';
import Config from './app.config';

import staticBootstrap from './staticBootstrap/lib';

import CarsNgActiveTest from './carsNgActiveTest';
import CarsNgEmployees from 'cars-ng-employees';
import printTracking from './printTracking';
/**
 * Add component imports here
 */
import './app.scss';
import ActiveEngage from './activeEngage';
import AsyncDataTracking from './asyncDataTracking';


import CarsScript from './carsScript';
import EmployeeDataAdapter from './employeeDataAdapter';
import dealerPhoneCta from './dealerPhoneCta';
import PartnerMarketplace from './partnerMarketplace';
import PreviousNext from './previousNext';
import PhotoLightboxModal from './photoLightboxModal';
import SmoothScroll from './smoothScroll';
import SearchResultsLink from './searchResultsLink';
import SimilarVehicles from './similarVehicles';
import TypModal from './typModal';
import VdpStatTrackingService from './vdpStatTrackingService';
import DealerChatButton from './dealerChat/dealerChatButton';
import DealerChatLink from './dealerChat/dealerChatLink';
import EmployeeCarousel from './employeeCarousel';
import LeadForm from './leadForm';
import PhotoLightbox  from './photoLightbox';
import CalculatorForm from './paymentCalculator';
import StickyNav from './stickyNav';
import secureCreditApplication from './secureCreditApplication';
import vdpsave from './vdpSaveVehicle';
import vdpMyAlerts from './vdpSaveVehicle/vdpMyAlerts';
import CarsNativeTwinAd from './nativeTwinAd';
import postleadSurvey from './postLeadSurvey';
import StarRating from './starRatings';
import VdpAbandonCapture from './vdpAbandonCapture';
import ShadowSettings from './shadowSettings';
import VdpConsumerReviewSection from './vdpConsumerReviewSection';
import VdpConsumerReviewTags from './vdpConsumerReviewTags';
import VdpWrapper from './vdpWrapper';
staticBootstrap.bootstrap();

let hyundaiPromotion = document.querySelector('.hyundai-promotion');

let isDIChatLoaded = false;

if (hyundaiPromotion){
    let hyundaiPromotionButton = hyundaiPromotion.querySelector('button');
    hyundaiPromotionButton.disabled = false;

    let testDriveData = {};

    (function (w, d) {
        hyundaiPromotionButton.addEventListener('click', ()=>{
            testDriveData = {
                ...hyundaiPromotionButton.dataset
            };

            if (!isDIChatLoaded) {
                hyundaiPromotion.classList.add('loading');

                isDIChatLoaded = true;

                // var se = d.createElement('script');
                // se.type = 'text/javascript';
                // se.async = true;
                // se.src = 'https://econ.dealerinspire.com/l.js';
                // se.id = '_di-conv-loader';
                // se.setAttribute('data-guid', '5d56-1fe1-b48d1');
                // se.setAttribute('data-revision', '3');
                // var s = d.getElementsByTagName('script')[0];
                // s.parentNode.insertBefore(se, s);

                var se = d.createElement('script');
                se.type = 'text/javascript';
                se.async = true;
                se.src = 'https://econ.dealerinspire.com/l.test.js';
                se.id = '_di-conv-loader';
                se.setAttribute('data-guid', '5d56-d188-ef4b1');
                se.setAttribute('data-revision', '3');
                se.setAttribute('data-env', 'test');
                var s = d.getElementsByTagName('script')[0];
                s.parentNode.insertBefore(se, s);

                waitForDIChat();
            } else {
                if (window.DIConv) {
                    window.DIConv.forceStartConversation(`Hyundai $50 test drive offer`, testDriveData);
                }
            }
        });

        function waitForDIChat(){
            setTimeout(()=>{
                if (window.DIConv) {
                    hyundaiPromotion.classList.remove('loading');
                    window.DIConv.forceStartConversation(`Hyundai $50 test drive offer`, testDriveData);
                } else {
                    waitForDIChat();
                }
            }, 100);
        }
    }(window, document));
}

export default angular.module('cars.vdp', [
    // add app level angular modules here (alphabetically please :))
    ActiveEngage,
    AsyncDataTracking,
    CarsScript,
    CarsUiAngular,
    CarsNgActiveTest,
    CarsNgEmployees,
    EmployeeDataAdapter,
    CuiLazyLoader,
    DealerChatButton,
    DealerChatLink,
    dealerPhoneCta,
    EmployeeCarousel,
    LeadForm,
    NgAd,
    PhotoLightbox,
    PhotoLightboxModal,
    NgCookies,
    NgTracking,
    PartnerMarketplace,
    PreviousNext,
    SearchResultsLink,
    SimilarVehicles,
    SmoothScroll,
    TypModal,
    VdpStatTrackingService,
    CalculatorForm,
    ShadowSettings,
    StickyNav,
    secureCreditApplication,
    vdpsave,
    vdpMyAlerts,
    CarsNativeTwinAd,
    postleadSurvey,
    StarRating,
    VdpAbandonCapture,
    printTracking,
    VdpConsumerReviewSection,
    VdpConsumerReviewTags,
    VdpWrapper
])

    .config(Config)

    .name;

angular.bootstrap(document, ['cars.vdp']);
